<template>
  <div class="productlist-dialog-wrap" v-if="isUplodFilesDialogOpen">
    <div class="productlist-dialog">
      <!-- head -->
      <div class="pa-5">
        <h3>批次匯入CSV</h3>
      </div>
      <!-- step -->
      <div class="py-5 pl-5 pr-80px">
        <div class="stepper">
          <div class="stepper-header ml-10">
            <div class="page-divider"></div>
            <!-- 1 -->
            <div class="stepper-step active">
              <div class="stepper-text">上傳CSV或XLS</div>
            </div>
            <div class="page-divider"></div>
          </div>
        </div>
      </div>
      <!-- description -->
      <div class="px-5 pt-5">
        <h5>
          {{ message }}
          <a :href="exampleFile"
             class="ml-2"
             target="_blank">
            下載匯入範本
          </a>
        </h5>
      </div>
      <!-- body -->
      <div class="pa-5">
        <div
          class="productlist-dialog__upload-area"
          :class="{ active: currentStatus == 2 || currentStatus == 5 }"
        >
          <div class="text-center"
               :class="{
                 'text-center-body-fail': !isMatch,
               }"
               @drop="onChange"
               @dragenter="dragenter"
               @dragover.prevent>
            <div class="mt-42px">
              <v-icon style="font-size: 45px">insert_drive_file </v-icon>
            </div>
            <div class="mt-14px" v-if="currentStatus == 1">
              <input type="file" id="file" ref="import" @change="onChange" hidden>
              <button class="btn" @click="chooseFiles">上傳CSV檔案</button>
            </div>
            <div class="mt-14px" v-if="currentStatus == 2">
              <button class="btn">
                <v-icon class="mr-2 ink-01-emphasis--text"
                >attach_file</v-icon
                >
                <span @click="importFileCancel">{{ file.name }}</span>
                <v-icon class="ml-2 ink-01-emphasis--text" @click="importFileCancel"
                >cancel</v-icon
                >
              </button>
            </div>
            <div class="mt-10px">或將檔案拖曳至此</div>
          </div>
        </div>
      </div>
      <!-- foot -->
      <div class="pa-5 text-right">
        <button class="btn w-100px mr-10px" @click="cancelHandler">取消</button>
        <button
          class="btn w-100px btn-primary"
          :class="{ disabled: currentStatus == 1 }"
          @click="importFiles"
        >
          匯入
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Zeplin: https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f214b051a66767ffd9b99d1
import { mapActions } from 'vuex';

export default {
  props: {
    isUplodFilesDialogOpen: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '針對單筆多語言內容批次匯入，請參考範本檔案。',
    },
    exampleFile: {
      type: String,
      default: '#',
    },
    url: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    currentStep: 1,
    currentStatus: 1,
    isDrag: false,
    isMatch: true,
    file: null,
  }),
  methods: {
    ...mapActions(['import']),
    ...mapActions('notifications', ['success', 'error']),
    cancelHandler() {
      this.init();
      this.$emit('update:isUplodFilesDialogOpen', false);
    },
    importFiles() {
      if (this.currentStatus === 1) {
        return;
      }
      const formData = new FormData();
      formData.append('file', this.file, this.file.name);
      this.import({
        url: this.url,
        data: formData,
      }).then(() => {
        this.success('匯入成功');
        this.$emit('handleReload');
      });
      this.init();
      this.$emit('update:isUplodFilesDialogOpen', false);
    },
    importFileCancel() {
      this.init();
    },
    init() {
      this.currentStep = 1;
      this.currentStatus = 1;
      this.file = null;
    },
    dragleave(e) {
      e.preventDefault();
      this.isDrag = false;
      this.isMatch = true;
    },
    onChange(e) {
      e.preventDefault();
      const data = e.target.files || e.dataTransfer.files;
      if (!data.length) {
        this.isDrag = false;
        return;
      }
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].type.indexOf('vnd.openxmlformats-officedocument.spreadsheetml.sheet') === -1) {
          this.setFailFileTips();
          return;
        }
      }
      this.handleFileUpload(data[0]);
    },
    dragenter(e) {
      e.preventDefault();
      this.isDrag = true;
    },
    handleFileUpload(data) {
      this.file = data;
      this.currentStep = 2;
      this.currentStatus = 2;
    },
    setFailFileTips() {
      this.isMatch = false;
      setTimeout(() => {
        this.isMatch = true;
        this.isDrag = false;
      }, 1500);
    },
    chooseFiles() {
      this.$refs.import.click();
    },
  },
};
</script>

<style lang="scss">
.stepper {
  &-header {
    display: flex;
    .page-divider {
      align-self: center;
      margin-left: 20px;
      margin-right: 20px;
      flex-grow: 1;
      border-bottom: 1px solid #848fa0;
    }
  }
  &-step {
    display: flex;
    align-items: center;
    &.active {
      .stepper-icon {
        background-color: #1240a8;
      }
      .stepper-text {
        color: #1240a8;
      }
    }
  }
  &-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin-right: 10px;
    color: white;
    background-color: #848fa0;
    border-radius: 50%;
    &.active {
      background-color: #1240a8;
    }
  }
  &-text {
    color: #848fa0;
    &.active {
      color: #1240a8;
    }
  }
}

.productlist-dialog-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(133, 133, 133, 0.5);
  z-index: 100;
}

.productlist-dialog {
  width: 720px;
  margin: 0 auto;
  margin-top: 136px;
  background-color: #fff;
  border-radius: 4px;

  &__upload-area {
    height: 216px;
    border: solid 1px #848fa0;
    border-style: dashed;
    border-radius: 4px;

    &.active {
      border: solid 1px #194cc3;
      border-style: dashed;
      border-radius: 4px;
      background-color: #e8efff;
    }
  }
}
.text-center {

  &-body {
    height: 216px;
    border: 1px dashed #848fa0;
    text-align: center;
    border-radius: 4px;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #848fa0;
    }

    .btn {
      margin-top: 9px;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-drag {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #194cc3;
    background-color: #e8efff;
    color: #1e50c0;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #1e50c0;
    }

    div {
      margin-top: 10px;
    }
  }

  &-body-fail {
    height: 216px;
    text-align: center;
    border-radius: 4px;
    border: 1px dashed #f90000;
    background-color: #ffe7e7;
    color: #ff0000;

    .material-icons {
      margin-top: 44px;
      font-size: 40px;
      width: 40px;
      height: 40px;
      color: #ff0000;
    }

    div {
      margin-top: 10px;
    }
  }
}
</style>
